import { render, staticRenderFns } from "./ServiceCategoryNew.vue?vue&type=template&id=90a0dc68&scoped=true"
import script from "./ServiceCategoryNew.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryNew.vue?vue&type=script&lang=js"
import style0 from "./ServiceCategoryNew.vue?vue&type=style&index=0&id=90a0dc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a0dc68",
  null
  
)

export default component.exports